import { Table } from '@wyz/ui';
// eslint-disable-next-line @wyz/module/no-relative-import
import './table.scss';

type Props = React.PropsWithChildren;

function PurchaseTable({ children }: Props) {
  return (
    <Table className='product-table' style={{ tableLayout: 'fixed' }}>
      {children}
    </Table>
  );
}

export default PurchaseTable;
